import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const nav = useNavigate();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login");
      return;
    }
    const sessionId = match[1];
    exchangeSession(sessionId)
      .then((user) => {
        window.history.replaceState({}, "", "/perfil");
        if (user.role === "admin" || user.role === "operator") nav("/admin");
        else nav("/perfil");
      })
      .catch(() => nav("/login"));
  }, [exchangeSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 mx-auto animate-spin text-neutral-400" />
        <p className="mt-4 text-sm font-mono uppercase text-neutral-500">Iniciando sesión...</p>
      </div>
    </div>
  );
}
